module.exports = __webpack_public_path__ + "static/media/send-icon.c557bbf0.svg";